class PromoBanner extends HTMLElement {
  constructor() {
    super();
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    this.setup();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  setup() {
    this.btn = this.querySelector("[data-popup-btn]");
    if (!this.btn) return;

    this.btn.addEventListener("click", this._onClick);
  }

  cleanup() {
    if (this.btn) {
      this.btn.removeEventListener("click", this._onClick);
    }
  }

_onClick(e) {
  // Centralized: opens the ACTIVE popup (ROI / wizard / A-B assignment);
  // the offer-step skip only applies when the classic popup is the target.
  if (typeof window.siloOpenPopup === "function") {
    e.preventDefault();
    // 'minicart' source: the "Mini-cart coupon button opens" setting routes
    // this button. null = routed to Nothing -> do nothing.
    const kind = window.siloOpenPopup("promo_banner", "minicart");
    if (kind === null) return;
    if (kind === "popup" && typeof window.siloPopupManager?.skipToStep4 === "function") {
      window.siloPopupManager.skipToStep4();
    }
  } else if (window.siloPopupManager) {
    e.preventDefault();
    if (typeof window.siloPopupManager.open === "function") {
      window.siloPopupManager.open(); 
    }

    if (typeof window.siloPopupManager.skipToStep4 === "function") {
      window.siloPopupManager.skipToStep4(); 
    }
  }
  // No popup engine (popup.min.js not loaded): the link's own href (#silo-popup) opens the
  // popup's no-JS state via :target — nothing to do here.
}

}

customElements.define("promo-banner", PromoBanner);
